import { data } from '../../svg/MarkNoteUnread/data';
import { makeIcon } from '../makeIcon';

export const MarkNoteUnread = makeIcon(data, 'mark_note_unread', 'MarkNoteUnread');

export default MarkNoteUnread;
